/* Wishlist Logic for UNPLATED */

const WISHLIST_KEY = 'unplated_wishlist';

function getWishlist() {
  const saved = localStorage.getItem(WISHLIST_KEY);
  return saved ? JSON.parse(saved) : [];
}

function removeFromWishlist(handle) {
  let list = getWishlist();
  list = list.filter(item => item !== handle);
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  renderWishlist();
}

async function renderWishlist() {
  const grid = document.getElementById('wishlistGrid');
  const empty = document.querySelector('.empty-state');
  if (!grid) return;

  const handles = getWishlist();
  
  if (handles.length === 0) {
    grid.innerHTML = '';
    if (empty) empty.style.display = 'block';
    return;
  }

  if (empty) empty.style.display = 'none';
  grid.innerHTML = '<div class="loading">Loading your saved pieces...</div>';

  try {
    const products = await Promise.all(
      handles.map(handle => 
        fetch(`/products/${handle}.js`).then(res => res.json())
      )
    );

    grid.innerHTML = products.map(p => {
      const isComingSoon = p.price === 0;
      const imgSrc = p.featured_image
        ? p.featured_image.replace(/(\.(jpg|jpeg|png|gif|webp))/, '_600x600_crop_center$1')
        : '';
      const price = isComingSoon
        ? 'Coming Soon'
        : '₹' + (p.price / 100).toLocaleString('en-IN');
      const badge = isComingSoon
        ? '<span class="p-badge-v2 badge-soon-v2">coming soon</span>'
        : (p.tags && p.tags.includes('new'))
          ? '<span class="p-badge-v2 badge-new-v2">new</span>'
          : (p.tags && p.tags.includes('bestseller'))
            ? '<span class="p-badge-v2 badge-bs-v2">bestseller</span>'
            : '';
      const quickAdd = isComingSoon ? '' : `
        <button class="p-add-v2" data-quick-add="${p.id}" data-handle="${p.handle}" aria-label="Quick Add">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="18" height="18">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
        </button>`;

      return `
        <div class="p-card${isComingSoon ? ' p-card--coming-soon' : ''}" data-handle="${p.handle}">
          <a href="${p.url}" class="p-card-inner">
            <div class="p-img-wrap">
              ${imgSrc ? `<img src="${imgSrc}" alt="${p.title}" class="p-img" loading="lazy">` : ''}
              ${badge}
              <button class="p-remove" onclick="event.preventDefault(); event.stopPropagation(); removeFromWishlist('${p.handle}')" aria-label="Remove from wishlist">✕</button>
              ${quickAdd}
            </div>
            <div class="p-info-v2">
              <h3 class="p-name-v2">${p.title}</h3>
              <p class="p-meta-v2">${p.type || ''} · Solid 9K Gold</p>
              <div class="p-price-v2${isComingSoon ? ' p-price--soon' : ''}">${price}</div>
            </div>
          </a>
        </div>`;
    }).join('');

  } catch (err) {
    console.error('Error loading wishlist:', err);
    grid.innerHTML = '<div class="error">Something went wrong loading your saved pieces. Please try again.</div>';
  }
}

document.addEventListener('DOMContentLoaded', renderWishlist);
window.removeFromWishlist = removeFromWishlist; // Expose to global for onclick
